// start:ng42.barrel
export * from './IBaseRequest';
export * from './IHotel-IV2';
export * from './IHotelReservation-IV2';
export * from './IOffer';
export * from './IProductUse';
export * from './IProductUseGuestCount';
export * from './IRateRequest';
export * from './IReservationIds-IV2';
export * from './ISegment';
export * from './ITimePeriod';
export * from './IUserProfile-IV2';
export * from './ITimePeriod';
export * from './IIdentificationInfo';
export * from './IAddressWithoutIndex';
export * from './IPersonName';
export * from './ITelephone';
export * from './IEmail';
// end:ng42.barrel


// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/HotelReservationV2/index.ts